import { FormLabel, Slider } from "@mui/material";
import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { FormInputProps } from './InputInterface';
import styled from 'styled-components';

const DabaduSliderLabel = styled(FormLabel)`
  &.MuiFormLabel-root {
    font-size: 40px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.textColor};
    font-family: ${(props) => props.theme.fonts.primary};
    @media (max-width: 1650px) {
      font-size: 28px;
    }
  }
`;

const DabaduSliderInput = styled(Slider)`
  &.MuiSlider-root {
    color: ${(props) => props.theme.colors.checkboxColor};
  }
`;

export const SliderInput = ({
  name,
  control,
  setValue,
  label,
}: FormInputProps) => {
  const [sliderValue, setSliderValue] = React.useState<number>(30);

  useEffect(() => {
    if (sliderValue) setValue(name, sliderValue);
  }, [name, setValue, sliderValue]);

  const handleChange = (event: any, newValue: number | number[]) => {
    setSliderValue(newValue as number);
  };

  return (
    <>
      <DabaduSliderLabel component="legend">{label}</DabaduSliderLabel>
      <Controller
        name={name}
        control={control}
        render={({}) => (
          <DabaduSliderInput
            value={sliderValue}
            onChange={handleChange}
            valueLabelDisplay="auto"
            min={0}
            max={100}
            step={1}
          />
        )}
      />
    </>
  );
};